module.exports = __webpack_public_path__ + "static/media/Adobe_Illustrator_CC_icon 8.36710269.png";